import { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { UploadCloud } from "lucide-react";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/cms/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}

export default function UploadButton({ onUploaded, label = "Téléverser une image", multiple = false, testId }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const url = await uploadImage(f);
        onUploaded(url);
      }
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/*" multiple={multiple} className="hidden" onChange={handle} data-testid={testId} />
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testId}-btn`}>
        <UploadCloud size={15} className="mr-1.5" /> {busy ? "Envoi…" : label}
      </Button>
    </>
  );
}
